export class ProcessErrorObject {

  constructor(private name: string, private description: string, private errorDate: Date) {

  }

  public getName(): string {
    return this.name;
  }

  public getErrorDate(): Date {
    return this.errorDate;
  }

  public getDescription(): string {
    return this.description;
  }
}
